<script>
	import { Col, Row, Image, Button } from "@sveltestrap/sveltestrap";
	import { convert, convertDateOnly } from "../../../services/helpers";
	import { navigate } from "svelte-routing";

	export let detailData;
	export let telematicsData;
</script>

<Row class="" style="min-height:0">
	<Col xs={9}>
		<Row class="my-3">
			<Col><span>Platform</span></Col>
			<Col>
				<b>{detailData.platformName}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Telematics Provider</span></Col>
			<Col>
				<b>{telematicsData?.provider || "-"}</b>
			</Col>
		</Row>
		<Row class="">
			<Col><span>No. of Seats</span></Col>
			<Col>
				<b>{detailData.numSeats}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Fuel Type</span></Col>
			<Col>
				<b>{detailData.fuelTypeName}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Boot Space</span></Col>
			<Col>
				<b>{detailData.bootSpace}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Description</span></Col>
			<Col>
				<b>{detailData.description}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Vehicle Brand</span></Col>
			<Col>
				<b>{detailData.vehicleMakeName}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<!-- DATA MISSING -->
			<Col><span>Charging Port location</span></Col>
			<Col>
				<b>{detailData.chargingPortLocation || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Vehicle Type</span></Col>
			<Col>
				<b>{detailData.vehicleTypeName}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>IU Number</span></Col>
			<Col>
				<b>{detailData.iuNumber}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Chassis Number</span></Col>
			<Col>
				<b>{detailData.chassisNumber}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Engine Number</span></Col>
			<Col>
				<b>{detailData.engineNumber}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Price Group</span></Col>
			<Col>
				<b>{detailData.priceGroupName}</b>
			</Col>
		</Row>
		{#if detailData.fuelTypeName === "Electric"}
			<Row class="my-3">
				<Col><span>Station ID</span></Col>
				<Col>
					<b> {detailData.stationId || "-"}</b>
				</Col>
			</Row>
			<Row class="my-3">
				<Col><span>Max. EV distance</span></Col>
				<Col>
					<b>{detailData.maxEvDistance || "-"}</b>
				</Col>
			</Row>
		{/if}
		<Row class="my-3">
			<Col><span>Fuel (L)/Battery <br />Capacity (kWh)</span></Col>
			<Col>
				<b>{detailData.capacity || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Fuel/Battery <br />Efficiency (km)</span></Col>
			<Col>
				<b>{detailData.efficiency || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Car Asset Owner</span></Col>
			<Col>
				<b>{detailData.assetOwnerName}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<!-- DATA MISSING -->
			<Col><span>Total No. of Booking</span></Col>
			<Col>
				<b>{detailData.totalBooking || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Last Service Date</span></Col>
			<Col>
				{#if detailData.lastServiceDate}
					<b>{convert(detailData.lastServiceDate)}</b>
				{:else}
					<b>-</b>
				{/if}
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Last Cleaned Date</span></Col>
			<Col>
				{#if detailData.lastCleanedDate}
					<b>{convert(detailData.lastCleanedDate)}</b>
				{:else}
					<b>-</b>
				{/if}
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Current Mileage</span></Col>
			<Col>
				<b>{detailData.currentMileage || "-"} (km)</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>COE Start Date</span></Col>
			<Col>
				<b>{convertDateOnly(detailData.coeStartDate) || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>COE End Date</span></Col>
			<Col>
				<b>{convertDateOnly(detailData.coeEndDate) || "-"}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>VEP Expiry Date</span></Col>
			<Col>
				<b>{convertDateOnly(detailData.vepExpiryDate) || "-"}</b>
			</Col>
		</Row>
	</Col>
	<Col xs={10}>
		<Col class="d-flex justify-content-end">
			<Row>
				<Col>
					<Button
						on:click={() =>
							navigate(`/car-management/edit/${detailData.id}`)}
						class="themeButton primary">EDIT</Button
					>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
